import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { UsuarioService } from './usuario.service';
import { environment } from '../../environments/environment';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AuthGuard implements CanActivate {
    uid;
    cont = 0;
    sAcessos: String = 'dashboard;relatorio-comissao;relatorio-vendas;refresh;';
    bUsuarioCarregado = false;

    constructor(
        private af: AngularFireAuth,
        private router: Router,
        private usuarioService: UsuarioService,
        private toastr: ToastrService,
    ) {
        this.af.authState.subscribe(snap => {
            this.uid = snap.uid;
            // this.sAcessos = 'dashboard;';
            if (snap.uid !== environment.idCliente) {
                this.usuarioService.getFuncionario(snap.uid).subscribe(dados => {
                    this.sAcessos = 'dashboard;relatorio-comissao;relatorio-vendas;refresh;relatorio-boletos;';
                    this.bUsuarioCarregado = true;

                    if (dados) {
                        const dadosFuncionario: any = dados;
                        const permissoes = dadosFuncionario.Permissoes;

                        //Cadastros
                        if (permissoes.Cadastrar.Clientes) {
                            this.sAcessos = this.sAcessos + '/pages/novo-cliente;';
                        }
                        if (permissoes.Cadastrar.Fornecedores) {
                            this.sAcessos = this.sAcessos + '/pages/novo-fornecedor;';
                        }
                        if (permissoes.Cadastrar.Funcionarios) {
                            this.sAcessos = this.sAcessos + '/pages/novo-funcionario;';
                        }
                        if (permissoes.Cadastrar.Grupos) {
                            this.sAcessos = this.sAcessos + '/pages/novo-grupo;';
                        }
                        if (permissoes.Cadastrar.Produtos) {
                            this.sAcessos = this.sAcessos + '/pages/novo-produto;';
                        }

                        //Consultas
                        if (permissoes.Consultar.Clientes) {
                            this.sAcessos = this.sAcessos + '/pages/consultar-cliente;';
                        }
                        if (permissoes.Consultar.Fornecedores) {
                            this.sAcessos = this.sAcessos + '/pages/consultar-fornecedor;';
                        }
                        if (permissoes.Consultar.Funcionarios) {
                            this.sAcessos = this.sAcessos + '/pages/consultar-funcionario;';
                        }
                        if (permissoes.Consultar.Grupos) {
                            this.sAcessos = this.sAcessos + '/pages/consultar-grupo;';
                        }
                        if (permissoes.Consultar.Produtos) {
                            this.sAcessos = this.sAcessos + '/pages/consultar-produto;';
                        }
                    }
                });
            }
        });
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        // if (localStorage.getItem('login') === 'true') {
        if (this.validarURL(route.routeConfig.path)) {
            if (this.cont == 0 && localStorage.getItem('tela_atual') != 'Login') {
                return this.manterConectado();
            } else {
                this.cont++;
                return true;
            }
        } else {
            return false;
        }
        // }

        // this.af.signOut();
        // this.router.navigate(['/login']);
    }

    validarURL(url) {
                if (url !== '/login' && url !== 'RefreshComponent') {
            // if (url !== '/pages/pages' && url !== '/' && url !== '/pages/dashboard' && url !== 'dashboard' && url !== '/pages' && url !== '/login' && url !== 'RefreshComponent') {
            if (this.validarIncludes(url)) {
                return true;
            } else {
                this.toastr.error("Você não tem permissão para acessar esta URL", 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
                return false;
            }
        } else {
            return true;
        }
    }

    validarIncludes(url) {
        if (this.uid !== environment.idCliente && this.bUsuarioCarregado) {
            return this.sAcessos.includes(url) ? true : false;
        } else
            return true;
    }

    manterConectado() {
        if (localStorage.getItem('manter_conectado') === 'true') {
            return true;
        } else {
            this.af.signOut();
            this.router.navigate(['/login']);
            return false;
        }
    }
}
